import { Component, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { AppStoresLink } from 'src/app/models/News';
import { GlobalService } from 'src/app/services/global.service';

@Component({
    selector: 'app-mobile-app-badges',
    templateUrl: './mobile-app-badges.component.html',
    styleUrls: [
        './mobile-app-badges.component.css',
        './../../../../assets/css/custom-egd-1.css'
    ]
})
@TraceClassDecorator()
export class MobileAppBadgesComponent implements OnInit {
    appleStoreLink;
    googlePlayStoreLink;
    // appStoreLinksData:AppStoresLink[];
    error = false;
    constructor(private readonly globalService: GlobalService) {}

    async ngOnInit(): Promise<void> {
        let appStoreLinksData: AppStoresLink[] =
            await this.globalService.getAppLinks();
        for (let i = 0; i < appStoreLinksData.length; i++) {
            if (appStoreLinksData[i]['deviceType'] === 'ios') {
                this.appleStoreLink = appStoreLinksData[i]['link'];
            } else if (appStoreLinksData[i]['deviceType'] === 'android') {
                this.googlePlayStoreLink = appStoreLinksData[i]['link'];
            }
        }
    }

    openAppleStoreLink() {
        window.open(this.appleStoreLink, '_blank');
    }

    openAndriodStoreLink() {
        window.open(this.googlePlayStoreLink, '_blank');
    }
}
